import { Button, Flex, FlexProps, SimpleGrid, Text } from "@chakra-ui/react";
import { BlogInterface } from "../../constants/Blog";
import MenuDropdown from "../MenuDropdown";
import { Empty } from "../card/Empty";
import SearchInput from "../input/SearchInput";
import CategorizedVerticalBlogCard from "./CategorizedVerticalBlogCard";
import { PaginationInterface } from "../../constants/Pagination";
import Pagination from "../Pagination";

interface Props extends FlexProps {
  data: BlogInterface[] | undefined;
  onSearch: (query: string) => void;
  slugUrl: string;
  pagination: PaginationInterface | undefined;
  loaded: boolean;
  onSetPage: (page: number) => void;
}

const BlogList = ({
  data,
  onSearch,
  slugUrl,
  loaded,
  pagination,
  onSetPage,
  ...rest
}: Props) => {
  return (
    <>
      <Flex
        direction={{ base: "column", sm: "row" }}
        w={"full"}
        gap={{ base: "12px", sm: "8px", md: "12px" }}
        {...rest}
      >
        <SearchInput
          placeholder="Cari postingan blog..."
          onConfirm={(input) => {
            onSearch(input);
          }}
        />

        {/* <MenuDropdown slugUrl={slugUrl} /> */}

        <Button
          variant={"solid-sm-secondary"}
          w={{ base: "full", sm: "150px" }}
          fontSize={"14px"}
          h={"100%"}
          minH={"40px"}
        >
          Cari
        </Button>
      </Flex>

      <Text textStyle={"h-title"} w={"full"} mt={"30px"}>
        Blog Menarik Lainnya
      </Text>

      {data && data.length > 0 ? (
        <SimpleGrid
          gap={30}
          columns={{ base: 1, xs: 2, md: 3, lg: 3, xl: 4 }}
          pb={"40px"}
        >
          {data?.map((blog, index) => (
            <CategorizedVerticalBlogCard key={index} data={blog} />
          ))}
        </SimpleGrid>
      ) : (
        <Empty />
      )}

      {loaded && pagination && data && data?.length > 0 && (
        <Pagination
          mt={4}
          totalItems={pagination.total}
          pageSize={pagination.per_page}
          onPageChange={(page) => {
            onSetPage(page);
          }}
        />
      )}
    </>
  );
};

export default BlogList;
